import { matchesRef } from '../../../schema/validation/resourceObject'
import {
  type BoardObjectsTransform,
  type IncludedOfType,
  type IncludedRef,
  type IncludedType,
} from './types'

export const updateIncludedAttributes =
  <TType extends IncludedType>(
    ref: IncludedRef<TType>,
    attributes: Partial<IncludedOfType<TType>['attributes']>
  ): BoardObjectsTransform =>
  (draft) => {
    const resource = draft.included?.find(matchesRef(ref))
    if (!resource) return draft

    Object.assign(resource.attributes as object, attributes)
    return draft
  }
